import { APIRule, RuleDataProps, RuleSettings } from "../types";
import { API_URL } from "../../../../env";

function rulesArrayFrom(input: any): any[] {
    if (Array.isArray(input)) return input;
    if (input && Array.isArray(input.data)) return input.data;
    return [];
  }
export default async function saveSettingsToBackend(settings: RuleSettings, existing: APIRule[] | { data?: RuleDataProps[] } | null) {
    if (!existing) throw new Error("No server rules loaded yet");
    const arr = rulesArrayFrom(existing);
    const upd = (name: string, conditionPatch: any, nextName?: string, nextDescription?: string) => {
      const r = arr.find((x: RuleDataProps) => x.name.toLowerCase().includes(name.toLowerCase()));
      if (!r) return Promise.resolve(undefined);
      return fetch(`${API_URL}/api/v1/trade-rules/${r.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({
        name: nextName ?? r.name,
        description: nextDescription ?? r.description,
        condition: { ...r.condition, ...conditionPatch }
      }) });
    };
    // todo
    await Promise.all([
      // Max Risk
      upd(
        "Max Risk",
        { max_risk_percent: settings.maxRiskPercent, apply_to: "all_trades" },
        `Max Risk ${settings.maxRiskPercent}%`,
        `Không được để rủi ro vượt quá ${settings.maxRiskPercent}% tổng tài khoản`
      ),
      // No Overtrade
      upd(
        "No Overtrade",
        { max_positions: settings.maxPositions, max_lots_per_trade: settings.maxLotsPerTrade },
        "No Overtrade",
        `Không được mở quá nhiều vị thế. Tối đa ${settings.maxPositions} vị thế${settings.maxLotsPerTrade ? `, ${settings.maxLotsPerTrade} lot/giao dịch` : ''}`
      ),
      // Stop Loss Required (name/desc stable, just mirror requirement)
      upd(
        "Stop Loss",
        { require_stop_loss: true },
        "Stop Loss Required",
        "Bắt buộc phải đặt stop loss cho mọi giao dịch"
      ),
      // Max SL
      upd(
        "Max SL",
        { max_sl_percent: settings.maxSLPercent, apply_to: "all_positions", enforce_strict: true },
        `Max SL ${settings.maxSLPercent}%`,
        `Stop loss không được vượt quá ${settings.maxSLPercent}% tổng tài khoản`
      ),
      // Max Daily DD
      upd(
        "Max Daily DD",
        { max_dd_percent: settings.maxDailyDDPercent, window: "daily", apply_to: "account" },
        `Max Daily DD ${settings.maxDailyDDPercent}%`,
        `Tổng sụt giảm vốn (drawdown) trong ngày không vượt quá ${settings.maxDailyDDPercent}% equity đầu ngày`
      ),
      // RR Target Declared
      upd(
        "RR Target Declared",
        { min_rr_allowed: settings.minRRAllowed, require_rr_declared: true, apply_to: "all_trades" },
        "RR Target Declared",
        `Phải khai báo mục tiêu RR tối thiểu ${settings.minRRAllowed}`
      ),
      // Allowed Trading Sessions
      upd(
        "Allowed Trading Sessions",
        { allowed_sessions: settings.allowedSessions, violate_outside_session: settings.violateOutsideSession, apply_to: "all_trades" },
        "Allowed Trading Sessions",
        `Chỉ được phép giao dịch trong các khung giờ đã định${settings.violateOutsideSession ? ', vi phạm ngoài phiên bị tính lỗi' : ''}`
      ),
      // First Trade Must Have Goal
      upd(
        "First Trade Must Have Goal",
        { require_first_trade_goal: settings.requireFirstTradeGoal, window: "daily", apply_to: "first_trade_of_day" },
        "First Trade Must Have Goal",
        "Lệnh đầu tiên trong ngày phải khai báo mục tiêu RR/plan"
      ),
      // Max SL/TP Change
      upd(
        "Max SL/TP Change",
        { max_sl_tp_change_percent: settings.maxSLTPChangePercent, apply_to: "all_positions" },
        `Max SL/TP Change ${settings.maxSLTPChangePercent}%`,
        `Không được thay đổi SL/TP quá ${settings.maxSLTPChangePercent}% so với khoảng cách ban đầu`
      ),
    ]);
  }
